'use client';

import { Collapse, List } from '@coolblue-development/freddy';
import seeMoreNavigationElementsTrigger from '@coolblue-development/ga4-events/triggers/SegmentNavigation/seeMoreNavigationElementsTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import type { ReactNode } from 'react';

const Container = ({ children, collapsible }: { children: ReactNode; collapsible?: boolean }) => {
  const collapseTranslations = useFreddyTranslations('collapse');
  const { trackEvent } = useAnalytics();

  const list = (
    <List
      marker='none'
      mt={collapsible ? 0 : 200}
      ml={400}
      gap='none'
      sx={theme => ({
        '& > li:first-of-type': {
          paddingTop: theme.spacing[200]
        }
      })}
    >
      {children}
    </List>
  );

  if (collapsible) {
    return (
      <Collapse
        translations={collapseTranslations}
        sx={theme => ({
          button: { paddingLeft: theme.spacing[400], paddingTop: theme.spacing[100] }
        })}
        onToggle={isOpen => {
          if (isOpen) {
            trackEvent(
              seeMoreNavigationElementsTrigger({
                content: collapseTranslations.labelCollapsed
              })
            );
          }
        }}
      >
        {list}
      </Collapse>
    );
  }

  return list;
};

export default Container;
